import React, { Component } from "react";
import styles from "./ImageSlide.module.scss";
import { slideProps } from "../../../interfaces/interfaces";

class ImageSlide extends Component<slideProps> {
  constructor(props: slideProps) {
    super(props);
  }

  render() {
    const properties = {
      backgroundSize: "cover",
      backgroundPosition: "center"
    };

    const currentBackgroundProperties = {
      backgroundImage: `url(${this.props.imageURL})`,
      ...properties
    };

    const nextBackgroundProperties = {
      backgroundImage: `url(${this.props.nextImageURL})`,
      ...properties
    };

    //<div style={nextBackgroundProperties} className={styles.imagePane} />
    return (
      <div id={styles.imageContainer}>
        <div
          style={currentBackgroundProperties}
          id={styles[this.props.fading]}
          className={styles.imagePane}
        />
      </div>
    );
  }
}

export default ImageSlide;
